















































































































import { Component, Prop, Vue } from "@/shared/vuepack";
import {
  HsabExpenseCategory,
  HsabExpenseFormMode,
  HsabExpenseReimbursementResponse,
  HsabSsoDestination,
  HsabExpenseDisplayStatus,
} from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import HsabExpenseCardRowExpenseDetail from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseDetail.vue";
import HsabExpenseCardRowPayee from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPayee.vue";
import HsabExpenseCardRowExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpenseEvidence.vue";
import HsabExpenseCardRowInsuranceClaim from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowInsuranceClaim.vue";
import HsabExpenseCardRowDenial from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowDenial.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsabRepayClaimExpanded
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabRepayClaimExpanded.vue";
import HsabExpenseCardRowPaymentDetail
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowPayment.vue";
import HsabExpenseCardRowRepayments
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowRepayments.vue";
import HsabExpenseCardRowInformationRequest
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowInformationRequest.vue";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabExpenseEvidenceStore } from "@/employee/store/hsabExpenseEvidence";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";

@Component({
  computed: {
    HsabSsoDestination () {
      return HsabSsoDestination;
    }
  },
  components: {
    HsabExpenseCardRowRepayments,
    HsabExpenseCardRowPaymentDetail,
    GenericLoadingSpinner,
    SsoDeepLink,
    HsabRepayClaimExpanded,
    HsabExpenseCardRowDenial,
    HsabExpenseCardRowExpenseEvidence,
    HsabExpenseCardRowInsuranceClaim,
    HsabExpenseCardRowPayee,
    HsabExpenseCardRowExpenseDetail,
    HsabExpenseCardRowInformationRequest,
    Button
  }
})
export default class HsbExpenseCardRowExpanded extends Vue {
  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();
  hsabExpenseEvidenceStore = useHsabExpenseEvidenceStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  isAddingAdditionalEvidence = false;
  isUploadingFilesToSubmittedExpense = false;
  showRepayClaimModal = false;
  stagedFilesForUpload = [];
  showDeleteConfirmationModal = false;
  hsabExpenseStore = useHsabExpenseStore();

  get hasOverflowReimbursements () {
    return this.reimbursement
        && this.reimbursement.overflowReimbursements
        && this.reimbursement.overflowReimbursements.length > 0;
  }

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }
  mounted () {
    this.hsabExpenseEvidenceStore.loadEvidenceForExpense(this.expense.hsabExpenseId);
  }
  get showInsuranceClaim (): boolean {
    return this.hsabExpenseFormStore.isReadonly
      && this.expense
      && this.expense.linkedClaimNumbers
      && this.expense.linkedClaimNumbers.length > 0;
  }
  get existingEvidenceCount (): number {
    if (this.expense && this.expense.hsabExpenseId) {
      const existingEvidence = this.hsabExpenseEvidenceStore.getExpenseEvidenceById(this.expense.hsabExpenseId);
      return existingEvidence ? existingEvidence.length : 0;
    }
    return 0;
  }
  get showExpenseEvidence (): boolean {
    return !this.hsabExpenseFormStore.isReadonly
        || this.existingEvidenceCount > 0
        || (this.expense && this.expense.isFileUploadAllowed);
  }
  get expenseCategory (): HsabExpenseCategory {
    return this.expense.expenseCategory;
  }
  get hasReimbursement (): boolean {
    return this.expense !== null && this.expense.reimbursement !== null;
  }
  get reimbursement (): HsabExpenseReimbursementResponse {
    return this.expense.reimbursement;
  }
  get showDenialReasons (): boolean {
    if (this.hasOverflowReimbursements) {
      return false;
    }
    const hasReimbursement = this.expense && this.expense.reimbursement;
    const hasDenialReasons = hasReimbursement
        && this.expense.reimbursement.denialReasons
        && this.expense.reimbursement.denialReasons.length > 0;
    const hasDeniedAmount = hasReimbursement && this.expense.reimbursement.deniedAmount > 0;

    return hasReimbursement && (hasDenialReasons || hasDeniedAmount);
  }
  get showInformationRequests (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.informationRequests
        && this.expense.reimbursement.informationRequests.length > 0;
  }
  get showRepayments (): boolean {
    return this.hsabExpenseFormStore.repaymentsDue.length > 0;
  }

  handleRepayClaimClick () {
    this.showRepayClaimModal = true;
  }
  handleOnRepayClaimClose () {
    this.showRepayClaimModal = false;
  }
  get hasClaimNumber () {
    return this.expense &&
        this.expense.reimbursement &&
        ! this.isStringNullOrEmpty(this.expense.reimbursement.externalReimbursementId);
  }

  get canEditSubmittedExpense (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.planName === "Health Savings Account";
  }

  isStringNullOrEmpty (str) {
    return str === undefined || str === null || str === "";
  }

   handleClose () {
   this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.none);
  }

  handleAddedFiles (files) {
    this.isAddingAdditionalEvidence = true;
    this.stagedFilesForUpload = files;
  }
  handleAddFilesAfterSubmitted () {
    const hasStagedFiles = this.stagedFilesForUpload && this.stagedFilesForUpload.length > 0;
    const hasShoeboxEvidence = this.hsabExpenseFormStore.hasShoeboxEvidenceAttached;

    if (!this.expense || (!hasStagedFiles && !hasShoeboxEvidence)) {
      return;
    }

    this.isUploadingFilesToSubmittedExpense = true;
    this.hsabExpenseEvidenceStore.UploadFilesToSubmittedHsabExpense(
            this.expense.hsabExpenseId,
            this.stagedFilesForUpload,
            this.expense.reimbursement.isHsaReimbursement)
        .then(_ => {
          this.isUploadingFilesToSubmittedExpense = false;
          const managedExpensesStore = useManagedExpenseStore();
          managedExpensesStore.reloadCurrentPage();
          this.handleClose();
        })
        .catch(err => {
          this.isUploadingFilesToSubmittedExpense = false;
        });
  }
  handleEditSubmittedExpense () {
    this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.createOrEdit);
    this.hsabExpenseFormStore.recentlySubmitted = false;
  }

  get showDeleteExpenseButton (): boolean {
    return this.expense.reimbursement &&
        this.expense.reimbursement.paidAmount === 0 &&
        (!this.expense.reimbursement.repayments || this.expense.reimbursement.repayments.length === 0) &&
        (this.expense.reimbursement.displayStatus === HsabExpenseDisplayStatus.ReceiptNeeded ||
            this.expense.reimbursement.displayStatus === HsabExpenseDisplayStatus.ReceiptOverdue ||
            this.expense.reimbursement.displayStatus === HsabExpenseDisplayStatus.NewReceiptNeeded);
  }

  confirmDelete () {
    this.hsabExpenseStore.deleteExpense(this.expense.hsabExpenseId);
    this.closeDeleteConfirmationModal();
    this.handleClose();
  }

  closeDeleteConfirmationModal () {
    this.showDeleteConfirmationModal = false;
  }

}
